<template>
    <button>
        <slot />
    </button>
</template>

<script setup>

</script>